<template>
    <div class="get-started-container">
        <p class="title">Get Started</p>
        <div class="divider"></div>
        <div class="stepper-progress">
            <p class="title">Let's get you up to speed</p>
            <div class="progress-wrapper">
                <Progress :status="stepStatus" :disabled="getStartedInfo.disabled" />
            </div>
        </div>
        <div v-if="!isMobile" class="steps-wrapper">
            <Steps
                :steps="getStartedSteps"
                :status="STEP_STATUS"
                :getStartedInfo="getStartedInfo"
            />
        </div>
        <div v-else class="steps-wrapper">
            <MobileSteps
                :steps="getStartedSteps"
                :status="STEP_STATUS"
                :getStartedInfo="getStartedInfo"
            />
        </div>
        <Congratulations
            v-if="getStartedInfo.status !== null"
            :status="getStartedInfo.status"
            :profileRole="role"
        />
    </div>
</template>
<script>
    import useGetStarted from '@/composables/features/get-started/useGetStarted.js'
    import useCheckScreen from '@/composables/useCheckScreen.js'
    import Progress from './parts/Progress.vue'
    import Steps from './parts/Steps.vue'
    import MobileSteps from './parts/MobileSteps.vue'
    import Congratulations from './parts/Congratulations.vue'

    export default {
        name: 'GetStarted',
        components: { Progress, Steps, MobileSteps, Congratulations },
        props: {
            role: {
                required: true,
                type: String,
                validator: (v) => ['venue', 'artist'].includes(v)
            }
        },
        setup(props) {
            const { STEP_STATUS, load, role, getStartedSteps, stepStatus, getStartedInfo } =
                useGetStarted(props)

            const { isMobile } = useCheckScreen()

            return {
                STEP_STATUS,
                load,
                role,
                getStartedSteps,
                getStartedInfo,
                stepStatus,

                isMobile
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    $mobileMax: 600px;

    @media screen and (max-width: $mobileMax) {
        .get-started-container {
            padding: 64px 16px 16px 16px !important;

            .stepper-progress {
                flex-direction: column !important;
                gap: 16px !important;
            }
        }
    }
    .get-started-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 24px;
        width: 100%;
        max-width: 1170px;
        min-width: 320px;
        padding: 60px;

        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        .title {
            color: #dedede;
            font-family: 'Instrument Sans';
            font-size: 44px;
            font-style: normal;
            font-weight: 500;
            line-height: 110%;
            letter-spacing: -1.76px;
        }
        .divider {
            width: 100%;
            height: 1px;
            background: #646464;
            margin-bottom: 8px;
        }
        .stepper-progress {
            margin-bottom: 8px;
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 80px;

            .title {
                color: #dedede;
                font-family: 'Instrument Sans';
                font-size: 26px;
                font-style: normal;
                font-weight: 500;
                line-height: 120%;
                letter-spacing: -0.52px;
                text-wrap: nowrap;
            }
            .progress-wrapper {
                width: 100%;
            }
        }
        .steps-wrapper {
            width: 100%;
        }
    }
</style>
